export default __webpack_public_path__ + "static/media/portfolio-midios-4.e5ed4d97.png";